import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchNewsletterStats,
  fetchNewsletterSubscribers,
  sendNewsletterDigest,
} from './newsletter-client';

export const newsletterStatsQueryKey = ['admin', 'newsletter-stats'] as const;
export const newsletterSubscribersQueryKey = ['admin', 'newsletter-subscribers'] as const;

export function useNewsletterStats() {
  return useQuery({
    queryKey: newsletterStatsQueryKey,
    queryFn: fetchNewsletterStats,
  });
}

export function useNewsletterSubscribers() {
  return useQuery({
    queryKey: newsletterSubscribersQueryKey,
    queryFn: fetchNewsletterSubscribers,
  });
}

export function useSendNewsletterDigest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (opts: { limit?: number } = {}) => sendNewsletterDigest(opts),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: newsletterStatsQueryKey });
    },
  });
}
